import { JSX, useEffect, useState } from "react";
import { wafflesKeyColumnName } from "@app/shared/waffles";
import { Waffles } from "@app/shared/waffles/Waffles";
import { FacilityModel } from "@app/projects/servicing-provider/providerAffiliation";


interface FacilitiesAccordionProps {
  facilities: FacilityModel[];
}

interface FacilitiesTableData {
  [wafflesKeyColumnName]: string;
  ccn: string;
  name: string;
  type: string;
}

const FacilitiesAccordion = (props: FacilitiesAccordionProps): JSX.Element => {
  const [facilityData, setFacilityData] = useState<FacilitiesTableData[]>([]);
  /* oxlint-disable sort-keys */
  useEffect(() => {
    const facilities: FacilitiesTableData[] = props.facilities.map((facility, index) => {
      return {
        name: facility.name,
        ccn: facility.ccn,
        key: index.toString(),
        type: facility.facilityType
      }
    })
    setFacilityData(facilities);
  }, []);
  /* oxlint-enable sort-keys */
  const columnConfig = ({
    ccn: {
      displayText: "CCN",
      sizeContentToFit: true,
      testId: 'affiliation-facility-ccn'
    },
    name: {
      displayText: "Name",
      sizeContentToFit: true,
      testId: 'affiliation-facility-name'
    },
    type: {
      displayText: "Type",
      sizeContentToFit: true,
      testId: 'affiliation-facility-type'
    }
  });

  return (
    <>
      <Waffles<FacilitiesTableData>
        columns={columnConfig}
        data={facilityData}
        testId="provider-affiliation-facilities-waffles"
        fullWidth={true}
      />
    </>
  )
}

export default FacilitiesAccordion;
